import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
// Aliased import: ObjectBaseModeComponent is the framework mode-aware object base. We extend it
// here and add the Angular OnChanges / OnDestroy hooks it intentionally omits (it manages teardown
// via takeUntilDestroyed(destroyRef) and has no ngOnChanges). Subclasses can therefore forward
// super.ngOnChanges(changes) / super.ngOnDestroy() in a type-safe, runtime-safe way WITHOUT
// modifying the protected core component.
import {
    ObjectBaseModeComponent as MvsObjectBaseModeComponent
} from 'features/core/shared/object/mvs-object-base/object-base-mode.component';

/**
* Shared cn intermediate base for uiMode-aware object-component views.
*
* It exists solely to give cn view base classes a concrete super target for ngOnChanges /
* ngOnDestroy. ObjectBaseModeComponent (the framework base) declares neither hook by design, so a
* cn view that needs to react to @Input() changes (objectIdentifier) cannot call super on them.
* This intermediate provides safe, forwarding implementations:
*   - ngOnChanges(): forwards to the framework base if a future version adds the hook (guarded).
*   - ngOnDestroy(): forwards to the framework base if present; teardown otherwise relies on the
*     framework's takeUntilDestroyed(destroyRef), so no manual unsubscribe is required here.
*
* NOTE: this is a non-injectable abstract base (Angular @Directive without selector); it is never
* declared in a module and never instantiated directly.
*/
@Component({ template: '' })
export abstract class CnObjectModeViewBase extends MvsObjectBaseModeComponent implements OnInit, OnChanges, OnDestroy {

    override ngOnInit(): void {
        super.ngOnInit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // ObjectBaseModeComponent has no ngOnChanges today; forward defensively for forward-compat.
        const base = MvsObjectBaseModeComponent.prototype as Partial<OnChanges>;
        base.ngOnChanges?.call(this, changes);
    }

    ngOnDestroy(): void {
        // ObjectBaseModeComponent has no ngOnDestroy by design (uses takeUntilDestroyed); forward
        // defensively in case a future version adds one.
        const base = MvsObjectBaseModeComponent.prototype as Partial<OnDestroy>;
        base.ngOnDestroy?.call(this);
    }
}
